import { ShipTierColors, ShipTierNames } from "@voidex/contracts-ts";
import type { OwnedShip } from "../../hooks";
import { EmptyState } from "../shared/EmptyState";
import { ShipIcon } from "../shared/ShipIcon";

interface ShipSelectorProps {
	ships: OwnedShip[];
	selectedShipId: bigint | null;
	onSelect: (tokenId: bigint) => void;
	isLoading?: boolean;
}

export function ShipSelector({
	ships,
	selectedShipId,
	onSelect,
	isLoading = false,
}: ShipSelectorProps) {
	if (isLoading) {
		return (
			<div className="ship-selector">
				<div className="ship-selector__loading">
					<div className="loading-spinner" />
					<span>Loading ships...</span>
				</div>
			</div>
		);
	}

	if (ships.length === 0) {
		return (
			<div className="ship-selector">
				<EmptyState
					icon="🚀"
					title="No Ships Found"
					description="Visit the Shipyard to acquire a ship before starting a farming mission."
				/>
			</div>
		);
	}

	return (
		<div className="ship-selector">
			<h3 className="ship-selector__title">Select a Ship</h3>
			<div className="ship-selector__grid">
				{ships.map((ship) => {
					const isSelected = selectedShipId === ship.tokenId;
					const tierName = ShipTierNames[ship.tier];
					const tierColor = ShipTierColors[ship.tier];

					return (
						<button
							key={ship.tokenId.toString()}
							type="button"
							className={`ship-selector__card ${isSelected ? "ship-selector__card--selected" : ""}`}
							onClick={() => onSelect(ship.tokenId)}
						>
							<ShipIcon tier={ship.tier} size="lg" />
							<span className="ship-selector__token-id">#{ship.tokenId.toString()}</span>
							<span
								className="ship-selector__tier-badge"
								style={{ color: tierColor, borderColor: tierColor }}
							>
								{tierName}
							</span>
						</button>
					);
				})}
			</div>
		</div>
	);
}
